var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaskicon4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#DCFCE7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 33.3333V12L30.0632 20C30 20 29.9368 20 29.8737 20C29.8105 20 29.7474 20 29.6842 20C28.9474 20 28.2526 20.0889 27.6 20.2667C26.9474 20.4444 26.3158 20.6889 25.7053 21L14.5263 16V20.6667L22.1053 22.6667L14.5263 24.6667V29.3333L21.3474 26.2667C21.1789 26.7778 21.0526 27.2833 20.9684 27.7833C20.8842 28.2833 20.8421 28.8 20.8421 29.3333C20.8421 29.3333 20.8421 29.3444 20.8421 29.3667C20.8421 29.3889 20.8421 29.4 20.8421 29.4L12 33.3333ZM29.6842 36C27.9368 36 26.4474 35.35 25.2158 34.05C23.9842 32.75 23.3684 31.1778 23.3684 29.3333C23.3684 27.4889 23.9842 25.9167 25.2158 24.6167C26.4474 23.3167 27.9368 22.6667 29.6842 22.6667C31.4316 22.6667 32.9211 23.3167 34.1526 24.6167C35.3842 25.9167 36 27.4889 36 29.3333C36 31.1778 35.3842 32.75 34.1526 34.05C32.9211 35.35 31.4316 36 29.6842 36ZM31.7684 32.4667L32.6526 31.5333L30.3158 29.0667V25.3333H29.0526V29.6L31.7684 32.4667ZM14.5263 26.2667C14.5263 25.2 14.5263 24.2 14.5263 23.2667C14.5263 22.3333 14.5263 21.5778 14.5263 21V16V20.6667V24.6667V29.3333V26.2667Z",
    fill: "#16A34A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskicon4);
export default __webpack_public_path__ + "static/media/taskicon4.88cf341be921668bccb2f73b928c9d15.svg";
export { ForwardRef as ReactComponent };